import React,{useState,useEffect} from 'react'
import axios from 'axios'
import {Link} from 'react-router-dom'
import Panel from '../ui/Panel'
import './dashboard.css'

export default function PopularCountries() {
    const [data,setData]=useState([])
    const [isLoading,setIsLoading]=useState(true)

    useEffect(()=>{
        loadData()
    },[])

    const loadData=()=>{
        //setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'manager/dashboard/popularcountries/'+sessionStorage.getItem('SportID'),{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
              }
          })
        .then(res=>{
            setIsLoading(false)
            setData(res.data)
        }).catch(err=>{
            setIsLoading(false)

        })
      }

      // The countries this plan unlocks: [{label:"Greece", value:10}, ...]
      // value matches CountryIDINT. Returns null when the list is unusable,
      // and a null list means we cannot claim anything is locked.
      const planCountryIDs=()=>{
        try{
          const raw=JSON.parse(sessionStorage.getItem('appCountries'))
          if (!Array.isArray(raw)) return null
          const ids=raw.map(c=>Number(c && c.value)).filter(v=>Number.isFinite(v))
          return ids.length>0 ? ids : null
        }catch(err){
          return null
        }
      }

      const plural=(n,one,many)=>n===1 ? one : many

      const formatList=(names)=>{
        if (names.length===0) return ''
        if (names.length===1) return names[0]
        if (names.length<=4) return names.slice(0,-1).join(', ')+' and '+names[names.length-1]
        return names.slice(0,3).join(', ')+' and '+(names.length-3)+' more countries'
      }

      const countOf=(item)=>Number(item.c) || 0

      const allowedIDs=planCountryIDs()
      const isAllowed=(item)=>allowedIDs !== null && allowedIDs.indexOf(Number(item.CountryIDINT)) > -1

      // Everything below is derived from this one response — no extra request.
      const total=data.reduce((sum,item)=>sum+countOf(item),0)
      const accessible=allowedIDs===null
        ? total
        : data.reduce((sum,item)=>isAllowed(item) ? sum+countOf(item) : sum,0)
      const locked=total-accessible
      const lockedNames=allowedIDs===null
        ? []
        : data.filter(item=>!isAllowed(item) && countOf(item)>0).map(item=>item.Country)

      const maxCount=data.reduce((top,item)=>Math.max(top,countOf(item)),0)

      const dataList=data.map((item,index)=>{
        const value=countOf(item)
        const pct=maxCount>0 ? (value/maxCount)*100 : 0
        const code=String(item.CountryCode || '').slice(0,2).toUpperCase()

        return(
            <div className="country" key={item.CountryIDINT || index}>
                <span className="flag" aria-hidden="true">{code || '--'}</span>
                <div className="c-body">
                    <div className="c-name">{item.Country}</div>
                    <div className="c-track">
                        <div className="c-fill" style={{width:pct+'%', animationDelay:(0.05+index*0.06)+'s'}}/>
                    </div>
                </div>
                <div className="c-val num">{value}</div>
            </div>
        )
      })

  return (
    <Panel
      title="Top Countries"
      subtitle={!isLoading && data.length>0
        ? `${total} ${plural(total,'player','players')} across ${data.length} ${plural(data.length,'country','countries')}`
        : 'Players by country'}
    >
        {isLoading &&
          <div className="sk-list">
            <div className="skeleton sk-line"></div>
            <div className="skeleton sk-line"></div>
            <div className="skeleton sk-line short"></div>
          </div>
        }

        {!isLoading && data.length===0 &&
          <div className="empty">No countries to show yet.</div>
        }

        {!isLoading && data.length>0 &&
          <>
            <div className="scroll-body c-list">{dataList}</div>

            {locked>0 &&
              <p className="callout">
                You can see <b>{accessible}</b> of <b>{total}</b> {plural(total,'player','players')}.
                {' '}<b>{locked}</b> {plural(locked,'player','players')}
                {lockedNames.length>0 ? ' in '+formatList(lockedNames) : ''}
                {' '}{plural(locked,'is','are')} outside your plan.
                {' '}<Link to="/plans">Compare plans</Link>
              </p>
            }
          </>
        }
    </Panel>
  )
}
